const WebpackLogo = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="skill-icon"
    >
      <path
        d="M117.29 98.1L66.24 127V104.49L98 87L117.29 98.1ZM120.79 94.94V34.55L102.11 45.35V84.16L120.78 94.93L120.79 94.94ZM10.71 98.1L61.71 126.98V104.49L29.94 87L10.71 98.1ZM7.20996 94.94V34.55L25.89 45.35V84.16L7.20996 94.94ZM9.39996 30.64L61.76 1V22.76L28.21 41.21L27.94 41.36L9.39996 30.64ZM118.58 30.64L66.24 1V22.76L99.79 41.2L100.06 41.35L118.6 30.64H118.58ZM61.76 99.37L30.37 82.1V47.92L61.76 66V99.37ZM66.24 99.37L97.63 82.12V47.92L66.24 66V99.37ZM32.5 44L64 26.66L95.5 44L64 62.16L32.5 44Z"
        fill="#00E96C"
      />
    </svg>
  );
};

export default WebpackLogo;
